import type { BannerPositionType } from '@/types/banner';

export const HOME_BANNER_POSITION_BY_TYPE: Record<BannerPositionType, number> =
  {
    mobile: 8,
    horizontal: 25,
    vertical: 26,
    dashboard: 32,
    relatedJobs: 33,
    hrMarket: 30,
    jobList: 23,
  };

export const BANNER_VIEW_STORAGE_KEY = 'zangia.banner.views';
export const BANNER_VIEW_THRESHOLD = 0.8;
export const BANNER_AUTOPLAY_DELAY_MS = 5000;

export function getBannerImageSrc(file?: string): string {
  if (!file) {
    return '';
  }

  if (file.startsWith('/') || file.startsWith('http')) {
    return file;
  }

  return `${process.env.NEXT_PUBLIC_CDN_URL}/b/${file}`;
}
